import {
  GET_VENDORS,
  GET_VENDORS_SUCCESS,
  API_ERROR,
  GET_VENDORS_FOR_USER,
  GET_CLIENTS_TABLE_DATA_SUCCESS,
  GET_CLIENTS_TABLE_DATA,
  GET_CLIENTS_TABLE_DATA_FAILED,
  ADD_CLIENT,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAILED,
  POST_CLIENT_SUCCESS_MANAGER,
  POST_CLIENT_SUCCESS_MANAGER_SUCCESS,
  POST_CLIENT_SUCCESS_MANAGER_FAILED,
  OPEN_DELETE_CLIENT_MODAL,
  HIDE_DELETE_CLIENT_MODAL,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILED,
  GET_CLIENT,
  GET_CLIENT_SUCCESS_MANAGER,
  GET_CLIENT_FAILED,
  GET_CLIENT_SUCCESS_MANAGER_FAILED,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_SUCCESS_MANAGER_SUCCESS,
  RESET_CLIENT_FORM,
  UPDATE_CLIENT,
  UPDATE_CLIENT_FAILED,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_SUCCESS_MANAGER,
  UPDATE_CLIENT_SUCCESS_MANAGER_FAILED,
  UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS,
  GET_VENDOR_CONFIG,
  GET_VENDOR_EMAIL_CONFIG,
  GET_VENDOR_CONFIG_FAILED,
  GET_VENDOR_EMAIL_CONFIG_FAILED,
  GET_VENDOR_EMAIL_CONFIG_SUCCESS,
  GET_VENDOR_CONFIG_SUCCESS,
  GET_EXPERIENCES_FEATURES,
  GET_LANDING_SCREEN_FEATURES,
  GET_EXPERIENCES_FEATURES_FAILED,
  GET_LANDING_SCREEN_FEATURES_FAILED,
  GET_EXPERIENCES_FEATURES_SUCCESS,
  GET_LANDING_SCREEN_FEATURES_SUCCESS,
  UPDATE_CLIENT_FEATURES,
  UPDATE_CLIENT_FEATURES_FAILED,
  UPDATE_CLIENT_FEATURES_SUCCESS,
  RESET_CLIENT_SETTINGS_FORM,
  GET_VENDOR_PAYMENT_CONFIG,
  GET_VENDOR_PAYMENT_CONFIG_FAILED,
  GET_VENDOR_PAYMENT_CONFIG_SUCCESS,
  UPDATE_VENDOR_PAYMENT_CONFIG,
  UPDATE_VENDOR_PAYMENT_CONFIG_FAILED,
  UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS,
  GET_VENDORS_FOR_USER_SUCCESS,
  GET_VENDORS_FOR_USER_FAILED,
  UPDATE_CLIENT_SETTINGS
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  vendorsList: [],
  clientsTableData: null,
  deleteClientModalIsOpen: false,
  client: null,
  clientSuccessManager: null,
  vendorConfig: null,
  vendorEmailConfig: null,
  experiencesFeatures: [],
  landingScreenFeatures: [],
  vendorPaymentConfig: null,
  userVendorList: [],
  userVendorListFetchError: null,
}

const clients = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDORS_FOR_USER:
      state = {
        ...state,
        userVendorListFetchError: null,
        loading: true,
      }
      break
    case GET_VENDORS_SUCCESS:
      state = {
        ...state,
        loading: false,
        vendorsList: action.payload,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CLIENTS_TABLE_DATA:
    case ADD_CLIENT:
    case POST_CLIENT_SUCCESS_MANAGER:
    case DELETE_CLIENT:
    case GET_CLIENT:
    case GET_CLIENT_SUCCESS_MANAGER:
    case UPDATE_CLIENT:
    case UPDATE_CLIENT_SUCCESS_MANAGER:
    case GET_VENDOR_CONFIG:
    case GET_VENDOR_EMAIL_CONFIG:
    case GET_EXPERIENCES_FEATURES:
    case GET_LANDING_SCREEN_FEATURES:
    case UPDATE_CLIENT_FEATURES:
    case GET_VENDOR_PAYMENT_CONFIG:
    case UPDATE_VENDOR_PAYMENT_CONFIG:
      return {
        ...state,
        loading: true,
      }
    case GET_CLIENTS_TABLE_DATA_SUCCESS:
      return {
        ...state,
        clientsTableData: action.payload,
        loading: false,
      }
    case GET_CLIENTS_TABLE_DATA_FAILED:
    case ADD_CLIENT_FAILED:
    case POST_CLIENT_SUCCESS_MANAGER_FAILED:
    case DELETE_CLIENT_FAILED:
    case GET_CLIENT_FAILED:
    case GET_CLIENT_SUCCESS_MANAGER_FAILED:
    case UPDATE_CLIENT_FAILED:
    case UPDATE_CLIENT_SUCCESS_MANAGER_FAILED:
    case GET_VENDOR_CONFIG_FAILED:
    case GET_VENDOR_EMAIL_CONFIG_FAILED:
    case GET_EXPERIENCES_FEATURES_FAILED:
    case GET_LANDING_SCREEN_FEATURES_FAILED:
    case UPDATE_CLIENT_FEATURES_FAILED:
    case GET_VENDOR_PAYMENT_CONFIG_FAILED:
    case UPDATE_VENDOR_PAYMENT_CONFIG_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case ADD_CLIENT_SUCCESS:
    case POST_CLIENT_SUCCESS_MANAGER_SUCCESS:
    case DELETE_CLIENT_SUCCESS:
    case UPDATE_CLIENT_SUCCESS:
    case UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS:
    case UPDATE_CLIENT_FEATURES_SUCCESS:
    case UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_DELETE_CLIENT_MODAL:
      return {
        ...state,
        deleteClientModalIsOpen: true,
      }
    case HIDE_DELETE_CLIENT_MODAL:
      return {
        ...state,
        deleteClientModalIsOpen: false,
      }
    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        client: action.payload,
        loading: false,
      }
    case GET_CLIENT_SUCCESS_MANAGER_SUCCESS:
      return {
        ...state,
        clientSuccessManager: action.payload,
        loading: false,
      }
    case RESET_CLIENT_FORM:
      return {
        ...state,
        client: null,
        clientSuccessManager: null,
      }
    case GET_VENDOR_EMAIL_CONFIG_SUCCESS:
      return {
        ...state,
        vendorEmailConfig: action.payload,
        loading: false,
      }
    case GET_VENDOR_CONFIG_SUCCESS:
      return {
        ...state,
        vendorConfig: action.payload,
        loading: false,
      }
    
    case UPDATE_CLIENT_SETTINGS:
      return {
        ...state,
        vendorConfig: action.payload?.params,
        loading: false,
      }
    case GET_EXPERIENCES_FEATURES_SUCCESS:
      return {
        ...state,
        experiencesFeatures: action.payload,
        loading: false,
      }
    case GET_LANDING_SCREEN_FEATURES_SUCCESS:
      return {
        ...state,
        landingScreenFeatures: action.payload,
        loading: false,
      }
    case RESET_CLIENT_SETTINGS_FORM:
      return {
        ...state,
        vendorConfig: null,
        vendorEmailConfig: null,
        experiencesFeatures: [],
        landingScreenFeatures: [],
        vendorPaymentConfig: null,
      }
    case GET_VENDOR_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        vendorPaymentConfig: action.payload,
        loading: false,
      }
    case GET_VENDORS_FOR_USER_SUCCESS:
      state = {
        ...state,
        userVendorList: action.payload,
        loading: false,
      }
      break
    case GET_VENDORS_FOR_USER_FAILED:
      state = {
        ...state,
        userVendorListFetchError: action.payload,
        userVendorList: [],
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default clients
